import React, { useState, useEffect } from "react";
import chefCookingAnim from "../images/chef_cooking_animation.gif";

const cookingSteps = [
  {
    icon: "fi fi-rr-search",
    title: "Checking Fridge Ingredients",
    detail: "Analyzing selected ingredients and pairing compatible flavors...",
  },
  {
    icon: "fi fi-rr-flame",
    title: "Balancing Spices & Aromas",
    detail: "Selecting seasonings, herbs, and the ideal cooking technique...",
  },
  {
    icon: "fi fi-rr-restaurant",
    title: "Crafting Step-by-Step Instructions",
    detail: "Writing easy-to-follow culinary steps with exact prep times...",
  },
  {
    icon: "fi fi-rr-leaf",
    title: "Calculating Calories & Macros",
    detail: "Estimating nutritional breakdown and healthy dietary balance...",
  },
  {
    icon: "fi fi-rr-sparkles",
    title: "Plating Your Meal",
    detail: "Finalizing chef tips and presentation suggestions...",
  },
];

const chefTips = [
  "💡 Tip: Toasting whole spices for 30 seconds awakens their essential aromatic oils!",
  "💡 Tip: Save vegetable peels and ends in the freezer to make a rich homemade broth.",
  "💡 Tip: Squeezing fresh lemon right before serving instantly elevates dish acidity & brightness.",
  "💡 Tip: Never overcrowd your pan — giving food space ensures a crispy, golden sear.",
  "💡 Tip: Salt your cooking water well when preparing pasta or boiling vegetables.",
];

const Loading = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [progress, setProgress] = useState(18);
  const [tipIndex, setTipIndex] = useState(0);

  useEffect(() => {
    // Progress increment timer
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 90) {
          const next = prev + Math.floor(Math.random() * 8) + 4;
          return Math.min(92, next);
        }
        return prev;
      });
    }, 600);

    // Step rotator timer
    const stepInterval = setInterval(() => {
      setStepIndex((prev) => (prev + 1) % cookingSteps.length);
    }, 2800);

    // Tip rotator timer
    const tipInterval = setInterval(() => {
      setTipIndex((prev) => (prev + 1) % chefTips.length);
    }, 4500);

    return () => {
      clearInterval(progressInterval);
      clearInterval(stepInterval);
      clearInterval(tipInterval);
    };
  }, []);

  const currentStep = cookingSteps[stepIndex];

  return (
    <div className="cooking-stage-card text-center my-3">
      {/* ── Animated Cooking Chef Mascot ── */}
      <div className="cooking-chef-animation-wrap">
        <img
          src={chefCookingAnim}
          alt="AI Chef Cooking"
          className="cooking-chef-animation-img"
        />
        {/* Soft warmth glow below the animated chef */}
        <div className="flame-glow"></div>
      </div>

      {/* ── Dynamic AI Chef Status ── */}
      <div className="mb-3 px-2">
        <span
          className="badge rounded-pill px-3 py-1 mb-2 fw-bold text-success d-inline-flex align-items-center gap-1.5"
          style={{ background: "rgba(34, 197, 94, 0.12)", border: "1px solid rgba(34, 197, 94, 0.3)", fontSize: "11px" }}
        >
          <i className="fi fi-rr-chef-hat text-success"></i>
          <span>AI Chef is Cooking</span>
        </span>

        <h5 className="fw-bold text-dark mb-1" style={{ letterSpacing: "-0.2px" }}>
          {currentStep.title}
        </h5>
        <p className="text-secondary small mb-0" style={{ fontSize: "12.5px", minHeight: "36px" }}>
          {currentStep.detail}
        </p>
      </div>

      {/* ── Animated Shimmer Progress Bar ── */}
      <div className="px-3 mb-2">
        <div className="d-flex justify-content-between align-items-center mb-1.5">
          <small className="text-muted fw-semibold" style={{ fontSize: "11px" }}>
            Preparing Recipe...
          </small>
          <small className="fw-bold text-success" style={{ fontSize: "11px" }}>
            {progress}%
          </small>
        </div>
        <div className="shimmer-progress-track">
          <div className="shimmer-progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>

      {/* ── Chef Tips Carousel ── */}
      <div className="chef-tip-bubble mx-2">
        <span style={{ fontSize: "1.2rem" }}>👨‍🍳</span>
        <small className="text-dark fw-medium" style={{ fontSize: "11.5px", lineHeight: "1.4" }}>
          {chefTips[tipIndex]}
        </small>
      </div>
    </div>
  );
};

export default Loading;
